import type { CustomClaims, RMUser } from "../webapp/src/types";

/** A migrated certified staff member can act as an RM without a legacy profile document. */
export function createClaimRM(
    identity: { email?: string; name?: string },
    claims: CustomClaims | undefined,
): RMUser | undefined {
    const email = identity.email?.trim().toLowerCase();
    if (!email || claims?.staff !== true || claims.kfh_rm_certified !== true) return undefined;
    const rmId = /^([0-9]+)@kfh\.com$/.exec(email)?.[1];
    return {
        id: email,
        email,
        ...(rmId ? { rm_id: rmId } : {}),
        name_en: identity.name?.trim() || email,
        name_ar: "",
        active: true,
        certified: true,
        role: "rm",
        ...(claims.segment ? { segment: claims.segment } : {}),
        ...(claims.availableSegments ? { availableSegments: claims.availableSegments } : {}),
    };
}

